import PropTypes from 'prop-types'
import React, { useState } from 'react'

import { DatePicker } from '@/components/forms/DatePicker'
import { TextInput } from '@/components/forms/TextInput'
import { TrashIcon } from '@/components/icons'

/**
 *
 * CleanupDetailItem
 *
 */
const CleanupDetailItem = ({ item, canEdit, canDelete, loading, onDelete, onChange }) => {
  const [showDatePicker, setShowDatePicker] = useState(false)

  // Handle date value for display - prevent passing invalid values to DatePicker
  const dateValue = item.date && item.date !== 'Invalid Date' ? item.date : undefined

  return (
    <div className="mb-4 flex flex-col gap-4 border-b border-gray-200 pb-4">
      <div className="flex flex-col gap-4 sm:flex-row">
        <DatePicker
          disabled={loading || !canEdit}
          dataTestId={`date-${item.id}`}
          label="Date"
          format="YYYY-MM-DD"
          onChange={(value) => onChange(item.id, 'date', value)}
          show={showDatePicker}
          setShow={setShowDatePicker}
          name={`date-${item.id}`}
          value={dateValue}
        />
        <TextInput
          data-testid={`schedule-${item.id}`}
          label="Schedule"
          fullWidth
          value={item.schedule || ''}
          onChange={(e) => onChange(item.id, 'schedule', e.target.value)}
          disabled={loading || !canEdit}
        />
      </div>
      <div className="flex flex-col gap-4 sm:flex-row">
        <TextInput
          data-testid={`numberOfClaims-${item.id}`}
          label="Number of Claims"
          fullWidth
          type="number"
          step="1"
          min="0"
          value={item.numberOfClaims || ''}
          onChange={(e) => onChange(item.id, 'numberOfClaims', e.target.value)}
          disabled={loading || !canEdit}
        />
        {canEdit && canDelete && (
          <div className="flex items-end">
            <button
              aria-label="Delete cleanup detail"
              type="button"
              onClick={() => onDelete(item.id)}
              className="inline-flex items-center rounded-lg bg-transparent p-2 text-center text-sm font-medium text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-gray-300 disabled:cursor-not-allowed"
              disabled={loading}
              data-testid={`deleteCleanupDetail-${item.id}`}
            >
              <TrashIcon className="text-charcoal-800 h-5 w-5" />
            </button>
          </div>
        )}
      </div>
      <div className="flex flex-col gap-4 sm:flex-row">
        <TextInput
          data-testid={`hoursSpent-${item.id}`}
          label="Hours Spent"
          fullWidth
          type="number"
          step="0.01"
          min="0"
          value={item.hoursSpent || ''}
          onChange={(e) => onChange(item.id, 'hoursSpent', e.target.value)}
          disabled={loading || !canEdit}
        />
        <TextInput
          data-testid={`amountPerHour-${item.id}`}
          label="Amount Per Hour"
          fullWidth
          type="number"
          step="0.01"
          min="0"
          value={item.amountPerHour || ''}
          onChange={(e) => onChange(item.id, 'amountPerHour', e.target.value)}
          disabled={loading || !canEdit}
        />
      </div>
    </div>
  )
}

export default CleanupDetailItem

CleanupDetailItem.propTypes = {
  item: PropTypes.object.isRequired,
  canEdit: PropTypes.bool.isRequired,
  canDelete: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
}
